$ = require 'jquery'
ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ track, trackUe } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

# Mixin for views that have the option to display an invitation link
module.exports = class DisplayInvitationLinkView extends View

  _secretUrl: ->
    "#{ @model.url() }/invitationSecret"

  showInvitationLink: (e) ->
    @$('.js-show-invitation-link').addClass('hide')
    @$('.js-invitation-link-container').removeClass('hide')

    ApiPromise
      method: 'post'
      url: @_secretUrl()
    .get 'secret'
    .then (secret) =>
      # Yes, this is gross … but eventually we won't be responsible for
      # forming these URLs anyway, since they should be coming from the server
      invitationUrl = @model.get('url').replace ///
        (
          /b/[^/]+ # the /b/:shortlink portion of a board URL
          |
          /[^/]+$ # the /:orgname portion of an org URL
        )
        (.*)$
      ///, "/invite$1/#{ secret }$2"

      @$('.js-invitation-link')
      .val(invitationUrl)
      .focus()
      .select()
    .then =>
      trackUe('board menu', 'opens', 'board invitation link', '', '', 'by clicking add members', { boardId: @model.id })
      if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
        Analytics.sendTrackEvent({
          action: 'created',
          actionSubject: 'link',
          actionSubjectId: 'inviteToBoardLink',
          source: 'inviteToBoardInlineDialog',
          containers: {
            board: {
              id: @model.id
            }
          }
        })

    .done()

  clickInvitationLink: (e) ->
    trackUe('board menu', 'click', 'board invitation link', '', '', 'by clicking invitation link', { boardId: @model.id })
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendUIEvent({
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'inviteToBoardLink',
        source: 'inviteToBoardInlineDialog',
        containers: {
          board: {
            id: @model.id
          }
        }
      })

    $('.js-invitation-link').select()

  deactivateInvitationLink: (e) ->
    @$('.js-show-invitation-link').removeClass('hide')
    @$('.js-invitation-link-container').addClass('hide')
    @$('.js-invitation-link').val('')

    trackUe('board menu', 'disables', 'board invitation link', '', '', 'by clicking add members', { boardId: @model.id })
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendUIEvent({
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'inviteToBoardDisableLink',
        source: 'inviteToBoardInlineDialog',
        containers: {
          board: {
            id: @model.id
          }
        }
      })

    ApiPromise
      method: 'delete'
      url: @_secretUrl()
    .done()

  copyInvitationLink: (e) ->
    $('.js-invitation-link').select()
    trackUe('board menu', 'copy', 'board invitation link', '', '', 'by clicking add members', { boardId: @model.id })
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendUIEvent({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'inviteToBoardLinkCopyButton',
        source: 'inviteToBoardInlineDialog',
        containers: {
          board: {
            id: @model.id
          }
        }
      })
    document.execCommand('copy')

    clearTimeout(@hideTimeout)
    $('.js-hide-on-copy').hide()
    $('.js-show-on-copy').show()
    @hideTimeout = setTimeout =>
      $('.js-hide-on-copy').show()
      $('.js-show-on-copy').hide()
    , 2000
